import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { AiChat } from '@/components/dashboard/ai-chat';

export const Route = createFileRoute('/ai-chat')({
  component: AiChatPage,
});

function AiChatPage() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto flex h-screen flex-col px-4 py-6">
        <div className="mb-6">
          <h1 className="font-bold text-2xl tracking-tight">
            Assistente IA Financeiro
          </h1>
          <p className="text-muted-foreground">
            Converse com nossa IA para obter insights sobre suas finanças
          </p>
        </div>

        <div className="flex flex-1 flex-col overflow-hidden rounded-lg border border-border">
          <AiChat />
        </div>
      </div>
    </AuthGuard>
  );
}
